/* Product page redesign: "Read more" for long descriptions.
   Shows the first N lines (data-pdp-clamp) and a toggle when the text is longer. */
(function () {
  function setup(el) {
    if (el.dataset.ready) return;
    var body = el.querySelector('.pdp-clamp__body');
    var btn = el.querySelector('.pdp-clamp__toggle');
    if (!body || !btn || !body.offsetParent) return; // measured once visible
    var lines = parseInt(el.dataset.pdpClamp, 10) || 4;
    var probe = body.querySelector('p, li') || body;
    var lh = parseFloat(getComputedStyle(probe).lineHeight);
    if (isNaN(lh)) lh = parseFloat(getComputedStyle(probe).fontSize) * 1.5;
    var max = Math.round(lh * lines);
    el.dataset.ready = '1';
    if (body.scrollHeight <= max + 4) return;
    el.style.setProperty('--pdp-clamp-height', max + 'px');
    el.classList.add('is-clamped');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  }
  function init() { document.querySelectorAll('[data-pdp-clamp]').forEach(setup); }
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  // A closed accordion has nothing to measure until it opens
  document.addEventListener('toggle', function (e) {
    if (e.target.open) setTimeout(init, 50);
  }, true);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
